import { Link, useTitle } from "easy-page-router/react";
import Carousel from "../components/Carousel";
import Footer from "../components/Footer";
import { useHeaders } from "../../ssrh/client";

export default function NotFound() {

    useTitle("404 stránka nenalezena | TSO Krkonoše");
    useHeaders({
        title: "404 stránka nenalezena | TSO Krkonoše",
        description: "404 stránka nenalezena | TSO Krkonoše",
        image: window.location.origin + "/logo.png",
        canonical: window.location.origin + window.location.pathname,
    });

    return <>
        <main>
            <Carousel>
                <div className="big-logo" />
            </Carousel>
            <div className="content">
                <section>
                    <div className="page">
                        <h1>404 - stránka nenalezena</h1>
                        <p>
                            <Link to="/">Zpět na domovskou stránku</Link>
                        </p>
                    </div>
                </section>
            </div>
        </main>
        <Footer />
    </>;
}
